import {RouterView} from '@/routes/RouterView.js';
const BankAccount = _ => import(/* webpackChunkName: "js/split/BankAccount", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/BankAccount');
const ChangeWorkCenter = _ => import(/* webpackChunkName: "js/split/ChangeWorkCenter", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/ChangeWorkCenter');
const ScholarshipHistory = _ => import(/* webpackChunkName: "js/split/ScholarshipHistory", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/ScholarshipHistory');
const SocialSecurity = _ => import(/* webpackChunkName: "js/split/SocialSecurity", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/SocialSecurity');
const TutorsEvaluations = _ => import(/* webpackChunkName: "js/split/TutorsEvaluations", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/TutorsEvaluations');
const ReportIncident = _ => import(/* webpackChunkName: "js/split/ReportIncident", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/ReportIncident');
const TutorsEvaluationsPanel = _ => import(/* webpackChunkName: "js/split/TutorsEvaluationsPanel", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/TutorsEvaluationsPanel');
const UnreadMessages = _ => import(/* WebpackChunkName: "js/split/UnreadMessages", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/UnreadMessages');
const MessageHistory = _ => import(/* webpackChunkName: "js/split/MessageHistory", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/MessageHistory');
const YoungTrainingCertificate = _ => import(/* webpackChunkName: "js/split/YoungTrainingCertificate", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/YoungTrainingCertificate');

export default {
	path: '/becario',
	component: RouterView,
	children: [
		{
			path: 'cuenta-bancaria',
			component:  BankAccount,
			name: 'BankAccount',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'cambio-centro-de-trabajo',
			component:  ChangeWorkCenter,
			name: 'ChangeWorkCenter',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'historial-de-beca',
			component:  ScholarshipHistory,
			name: 'ScholarshipHistory',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'seguridad-social',
			component:  SocialSecurity,
			name: 'SocialSecurity',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'evaluaciones',
			component:  TutorsEvaluations,
			name: 'TutorsEvaluations',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'evaluar-tutor',
			component:  TutorsEvaluationsPanel,
			name: 'TutorsEvaluationsPanel',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'reportar',
			component:  ReportIncident,
			name: 'ReportIncident',
			meta:{
				auth: true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'mensajes-no-leidos',
			component: UnreadMessages,
			name:'UnreadMessages',
			meta:{
				auth:true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'historico-de-mensajes',
			component: MessageHistory,
			name:'MessageHistory',
			meta:{
				auth:true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: 'constancia-de-capacitacion',
			component: YoungTrainingCertificate,
			name:'YoungTrainingCertificate',
			meta:{
				auth:true,
				haveARelationshipWithCompany : true,
				requiredProfile: [2]
			}
		},
		{
			path: '*',
			redirect: '/404',
			meta: {
				guest: true,
			}
		}
	],

}
